'use client'

import { ErrorScreen } from '@/components/ErrorScreen'
import { useRouter } from 'next/navigation'
import { startTransition, useEffect } from 'react'

/*
 * Default export for route-segment error.tsx files. `reset()` alone only
 * re-renders the client tree, so an error thrown while the SERVER rendered the
 * page (e.g. a DB blip on /submit) would just throw again from the cached
 * payload. Refreshing first refetches the server render, so "Try again" really
 * retries. Not for global-error.tsx, which renders outside the router.
 */
export function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const router = useRouter()

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <ErrorScreen
      reset={() =>
        startTransition(() => {
          router.refresh()
          reset()
        })
      }
    />
  )
}
